import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { alertActions } from '../../../../../../_actions/alert.actions'
import { usersService } from '../../../../../../_services/users.service'
import { Alert, Button, Col, Modal, Row, Spinner } from 'react-bootstrap'

export default function RemoveLocationModal({ show, handleClose }) {
  const dispatch = useDispatch(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleCloseModal = () => {
    setError('')
    setLoading(false)
    setTimeout(() => {
      handleClose()
    }, 100);
  }
  
  const handleInactivate = () => {
    setError('')
    setLoading(true)
    usersService.removeFromLocationTeam()
    .then(() => {
      handleClose()
      dispatch(alertActions.success('Removed from location team.'));
    })
    .catch(() => {
      setError('Could not remove user from this location at this time. Please try again.');
    })
    .then(() => {
      setLoading(false)
    })
  }

  return (
    <Modal show={show} onHide={handleCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>Remove From Location</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        { error && <Alert variant='danger'>{ error }</Alert> }
        <Row>
          <Col>
             <p>Are you sure you want to remove this user from this location?</p>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row className='w-100 justify-content-end'>
          <Col xs='7'>
            <Button disabled={loading} onClick={handleInactivate} block variant='success'>
              { loading ? <Spinner size='sm' animation='border' /> : 'Yes, remove'}
            </Button>
          </Col>
          <Col xs='5'>
            <Button disabled={loading} onClick={handleCloseModal} block variant='secondary'>No, cancel</Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  )
}
